import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { SnackbarProvider } from "./context/SnackbarContext.tsx";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme/index.ts";
import { RegionProvider } from "./context/RegionContext.tsx";
// Initialize axios interceptor to add X-Region header to all requests
import "./api/axiosInstance";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RegionProvider>
      <SnackbarProvider>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </SnackbarProvider>
    </RegionProvider>
  </React.StrictMode>
);
